module.exports = __webpack_public_path__ + "static/media/296158.d23d0664.jpg";